import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import '../assets/style/RoleModals.css'
import { deleteUserApi } from "../api/roleMasterApi";

const DeleteUserConfirmModal = (props: any) => {
    const { toggle, openModal, userName, userId, setFlag } = props
    const dispatch: any = useDispatch();

    const handleDeleteUser = () => {
        dispatch(deleteUserApi(userId));
    };

    const handleCloseModal = () => {
        setFlag(false);
        toggle();
    };

    const closeBtn = (
        <img
            src={require('../assets/img/close_modal.svg').default}
            onClick={handleCloseModal}
            className="close-icon"
            alt="Close"
        />
    );

    const  storeDeleteUserRes  = useSelector((state: any) => state.roleMaster?.storeDeleteUserRes);
    useEffect(() => {
        if (storeDeleteUserRes?.response === 'deleted') {
            toggle();
            setFlag(true);
        }
    }, [storeDeleteUserRes]);

    return (
        <Modal isOpen={openModal} toggle={toggle} centered backdrop="static">
            <ModalHeader toggle={toggle} close={closeBtn}>
                Delete User
            </ModalHeader>
            <ModalBody>
                <span className="modal-text">
                    Are you sure you want to delete <b>{userName}</b>?
                </span>
            </ModalBody>
            <ModalFooter>
                <Button className="button extra-width" onClick={handleDeleteUser}>
                    Yes
                </Button>
                <Button className="resetButton extra-width" onClick={handleCloseModal}>
                    No
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default DeleteUserConfirmModal;